"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstantQuarantineRequestSchema = exports.PrepLabelRequestSchema = exports.NightlyQuarantineRequestSchema = exports.QueuedLotActionRequestSchema = exports.DeliverrOrderCdcRecordSchema = exports.DeliverrOrderSchema = exports.WarehouseResponseSchema = exports.WarehouseResponseLotItemSchema = exports.WarehouseEventSNSBodySchema = exports.SNSBodySchema = exports.BulkSetSkuStopShipByDaysRequestSchema = exports.CSVFileSchema = exports.SetStopShipByDaysConfigurationRequestSchema = exports.SetSkuStopShipByDaysRequestSchema = exports.SetGlobalStopShipByDaysRequestSchema = exports.GetFefoLotsRequestOptionsSchema = exports.LotActionSchema = exports.AddressSchema = exports.UpsertStateRequestSchema = exports.GetLotRequestSchema = exports.DskuSchema = void 0;
const fulfillment_order_client_1 = require("@deliverr/fulfillment-order-client");
const warehouse_client_1 = require("@deliverr/warehouse-client");
const zod_1 = require("zod");
const prep_service_client_1 = require("@deliverr/prep-service-client");
const LotState_1 = require("./LotState");
const PrepLabelResponse_1 = require("./PrepLabelResponse");
const LotStateSourceUser_1 = require("./LotStateSourceUser");
const StopShipByDaysApiResponse_1 = require("./StopShipByDaysApiResponse");
exports.DskuSchema = zod_1.z
    .string()
    .regex(/^D[0-9a-zA-Z]+$/)
    .length(11);
const validateLotData = (data, ctx) => {
    if (!data.lotNumber && !data.expirationDate) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ["custom"],
            message: "One of Lot Number or Expiration Date needs to be passed in",
        });
        return;
    }
    if (data.expirationDate) {
        const isValidDate = zod_1.z.date().safeParse(new Date(data.expirationDate)).success;
        if (!isValidDate) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.invalid_date,
                path: ["custom"],
                message: "The expiration date is invalid",
            });
        }
    }
};
exports.GetLotRequestSchema = zod_1.z
    .object({
    dsku: exports.DskuSchema,
})
    .merge(zod_1.z
    .object({
    lotNumber: zod_1.z.string(),
    expirationDate: zod_1.z.string(),
    poolName: zod_1.z.string(),
    sourceUser: zod_1.z.string(),
})
    .partial())
    .superRefine(validateLotData);
exports.UpsertStateRequestSchema = zod_1.z
    .object({
    org: zod_1.z.string(),
    dsku: exports.DskuSchema,
    lotNumber: zod_1.z.string().optional(),
    expirationDate: zod_1.z.string().optional(),
    state: zod_1.z.nativeEnum(LotState_1.LotState),
    sourceUser: zod_1.z.nativeEnum(LotStateSourceUser_1.SourceUser),
    poolName: zod_1.z.string().optional(),
})
    .superRefine(validateLotData);
exports.AddressSchema = zod_1.z.object({
    name: zod_1.z.string().min(1),
    company: zod_1.z.string().optional(),
    street1: zod_1.z.string().min(1),
    street2: zod_1.z.string().optional(),
    city: zod_1.z.string().min(1),
    state: zod_1.z.string().min(1),
    zip: zod_1.z.string().min(1),
    country: zod_1.z.string().min(1),
    phone: zod_1.z.string().optional(),
});
exports.LotActionSchema = zod_1.z
    .object({
    dsku: exports.DskuSchema,
    sellerId: zod_1.z.string(),
    lotNumber: zod_1.z.string(),
    expirationDate: zod_1.z.string(),
    poolName: zod_1.z.string(),
    address: exports.AddressSchema.optional(),
    packOf: zod_1.z.string().optional(),
    sourceUser: zod_1.z.nativeEnum(LotStateSourceUser_1.SourceUser).optional(),
    state: zod_1.z.union([zod_1.z.literal(LotState_1.LotState.QUARANTINED), zod_1.z.literal(LotState_1.LotState.REVIEW)]).optional(),
})
    .partial({
    lotNumber: true,
    expirationDate: true,
    poolName: true,
})
    .superRefine(validateLotData);
exports.GetFefoLotsRequestOptionsSchema = zod_1.z
    .object({
    offset: zod_1.z.coerce.number().int().nonnegative(),
    limit: zod_1.z.coerce.number().int().positive(),
})
    .partial();
exports.SetGlobalStopShipByDaysRequestSchema = zod_1.z.object({
    stopShipByDays: zod_1.z.number().nonnegative().int(),
});
exports.SetSkuStopShipByDaysRequestSchema = zod_1.z.object({
    msku: zod_1.z.string(),
    stopShipByDays: zod_1.z.number().nonnegative().int().lte(365),
});
exports.SetStopShipByDaysConfigurationRequestSchema = zod_1.z.object({
    type: zod_1.z.enum(Object.keys(StopShipByDaysApiResponse_1.StopShipByDaysConfigurationType)),
});
exports.CSVFileSchema = zod_1.z.object({
    filename: zod_1.z.string().min(1),
    mimetype: zod_1.z.string().min(1),
    encoding: zod_1.z.string().min(1),
    truncated: zod_1.z.boolean(),
    content: zod_1.z.any(),
});
exports.BulkSetSkuStopShipByDaysRequestSchema = zod_1.z.object({
    file: exports.CSVFileSchema,
});
// The body of the SNS message published by warehouse service
exports.SNSBodySchema = zod_1.z.object({
    Message: zod_1.z.string(),
    MessageId: zod_1.z.string(),
    MessageAttributes: zod_1.z.object({
        SnsFilterMessageType: zod_1.z.object({
            Type: zod_1.z.string(),
            Value: zod_1.z.string(),
        }),
    }),
    Type: zod_1.z.string(),
});
exports.WarehouseEventSNSBodySchema = zod_1.z.object({
    Message: zod_1.z.string(),
    MessageId: zod_1.z.string(),
    MessageAttributes: zod_1.z.any(),
    Type: zod_1.z.string(),
});
// The data model returned by warehouse service through SNS
exports.WarehouseResponseLotItemSchema = zod_1.z
    .object({
    locationDescription: zod_1.z.string().optional(),
    isSuccess: zod_1.z.coerce.boolean(),
    lotNumber: zod_1.z.string().nullish(),
    expirationDate: zod_1.z.string().nullish(),
})
    .superRefine(validateLotData);
exports.WarehouseResponseSchema = zod_1.z.object({
    requestId: zod_1.z.coerce.number().positive().optional(),
    response: zod_1.z.array(exports.WarehouseResponseLotItemSchema),
    result: zod_1.z.nativeEnum(warehouse_client_1.QuarantineResult).optional(),
    warehouseId: zod_1.z.string(),
    dsku: exports.DskuSchema,
});
// The data model returned by Fulfillment CDC
// We don't have a DeliverrOrder object Zod definition. Rather than spell out the entire object, I will just select
// the relevant fields for what we need it for.
exports.DeliverrOrderSchema = zod_1.z.object({
    id: zod_1.z.coerce.string(),
    status: zod_1.z.nativeEnum(fulfillment_order_client_1.OrderStatus),
    tags: zod_1.z.array(zod_1.z.nativeEnum(fulfillment_order_client_1.FulfillmentOrderTag)),
});
exports.DeliverrOrderCdcRecordSchema = zod_1.z.object({
    database: zod_1.z.string(),
    table: zod_1.z.string(),
    type: zod_1.z.string(),
    ts: zod_1.z.coerce.number(),
    data: exports.DeliverrOrderSchema,
    old: exports.DeliverrOrderSchema.partial(),
});
exports.QueuedLotActionRequestSchema = zod_1.z.object({
    action: zod_1.z.enum([LotState_1.LotState.QUARANTINE_REQUESTED, LotState_1.LotState.FULFILLMENT_REQUESTED]),
    request: exports.LotActionSchema,
});
exports.NightlyQuarantineRequestSchema = zod_1.z.object({
    action: zod_1.z.enum([LotState_1.LotState.QUARANTINE_REQUESTED, LotState_1.LotState.FULFILLMENT_REQUESTED]),
    warehouseRequestId: zod_1.z.coerce.number(),
});
exports.PrepLabelRequestSchema = zod_1.z
    .object({
    dsku: exports.DskuSchema,
    barcode: zod_1.z.string(),
    type: zod_1.z.nativeEnum(PrepLabelResponse_1.PrepLabelType),
    format: zod_1.z.enum([prep_service_client_1.BarcodeLabelFormat.ONE_UP, prep_service_client_1.BarcodeLabelFormat.THIRTY_UP]),
    lotNumber: zod_1.z.string().optional(),
    expirationDate: zod_1.z.string().optional(),
})
    .superRefine(validateLotData);
exports.InstantQuarantineRequestSchema = zod_1.z.object({
    quarantineRequest: exports.LotActionSchema,
    poolName: zod_1.z.string().optional(),
    quarantineReason: zod_1.z.nativeEnum(warehouse_client_1.QuarantineReason).optional(),
    requestedLotState: zod_1.z.enum([LotState_1.LotState.QUARANTINED, LotState_1.LotState.REVIEW]).optional(),
});
//# sourceMappingURL=Schema.js.map